module.exports = __webpack_public_path__ + "static/react-14e4234874219328d31520f6eb0d512a.png";